import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { useAssetApi } from "../api/index.ts";
import { assetQuery } from "./assetQuery.ts";

export type GetCachedAssetBlob = (assetId: string | null | undefined) => Promise<Blob | null>;

export const useGetCachedAssetBlob = (): GetCachedAssetBlob => {
  const queryClient = useQueryClient();
  const api = useAssetApi();

  return useCallback(
    async (assetId: string | null | undefined) => {
      const state = await queryClient.fetchQuery(assetQuery(api, assetId));
      return state ? state.blob : null;
    },
    [queryClient, api],
  );
};
